import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

export default class StepNavigators extends Component {
    render() {
        return (
            <>
                {
                    ((this.props.isQRActiveStep && this.props.error) ||
                        !this.props.isQRActiveStep) &&
                    <Button
                        variant="contained"
                        onClick={() => this.props.changeStep(this.props.activeStep - 1)}
                    >
                        {this.props.t('common:BACK')}
                    </Button>
                }
                <Button
                    variant="contained"
                    onClick={() => this.props.changeStep(this.props.activeStep + 1)}
                    disabled={
                        (!this.props.isSummaryActiveStep && !this.props.canFinish) ||
                        (this.props.isQRActiveStep && this.props.error)
                    }
                >
                    {
                        !this.props.isSummaryActiveStep
                            ? <span>{this.props.t('common:FINISH')}</span>
                            : this.props.isQRActiveStep
                                ? <span>{this.props.t('wizard:VERIFY_LICENCE')}</span>
                                : <span>{this.props.t('common:NEXT')}</span>
                    }
                </Button>
            </>
        );
    }
}
